<script lang="ts">
  import type {EnergyLabel} from "../../../../types/CinemaProductsDto.types.ts";
  import EnergyLabelSheet from "./EekSheet.svelte";

  type EekLabelProps = {
    labels: EnergyLabel[];
  }

  let {labels}: EekLabelProps = $props();

  /*                                                                                                                         */
  let activeLabel = $state<EnergyLabel | null>(null);

  const validLabels = $derived(labels.filter(label => label.colorHexcode && label.datasheetUri));
  const hasMultipleLabels = $derived(validLabels.length > 1);
</script>

<div class="energy-labels">
  {#each validLabels as label}
    <div class="energy-labels__label">
      <!-- svelte-ignore a11y_click_events_have_key_events -->
      <!-- svelte-ignore a11y_no_static_element_interactions -->
      <ofc-energy-label-v1
          as-button
          color={`#${label.colorHexcode}`}
          size="100"
          variant={label.category}
          version={label.version}
          onclick={() => activeLabel = label}
          oc-aria-label={`Energieeffizienzklasse ${label.category}`}
      ></ofc-energy-label-v1>

      <div class="energy-labels__description">
        {#if hasMultipleLabels}
          <span class="oc-copy-50">{label.descriptor}</span>
        {/if}
        <oc-link-v2
            variant="secondary"
            size={"50"}
            base64-href={btoa(label.datasheetUri)}
            target="_blank"
            oc-aria-label={`Produktdatenblatt ${label.descriptor}`}
        >
          Produktdatenblatt
        </oc-link-v2>
      </div>
    </div>
  {/each}
</div>

<!-- Two-way binding: this component sets activeLabel to open the sheet and EnergyLabelSheet resets it to null after closing -->
<EnergyLabelSheet bind:activeLabel/>

<style lang="scss">
  @use '@otto-ec/design-tokens/tokens';

  .energy-labels {
    display: flex;
    flex-direction: column;
    gap: tokens.$oc-semantic-spacing-25;
    margin-top: tokens.$oc-semantic-spacing-50;

    &__label {
      display: flex;
      align-items: center;
      gap: tokens.$oc-semantic-spacing-25;
    }

    &__description {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      flex: 0 1 100%;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
</style>
